<template>
  <div
    class="relative flex h-full min-w-0 flex-1"
    :class="{
      'overflow-hidden rounded-2xl bg-primary-100 dark:bg-primary-900':
        showSidePanel
    }"
  >
    <slot :show-side-panel="showSidePanel" />
    <div
      v-if="showSidePanel"
      class="ai-assistant-anchor h-full shrink-0"
      :style="{ width: dockedWidth + 'px' }"
    />
    <div
      v-if="showSidePanel"
      class="absolute inset-x-0 bottom-0 h-52 bg-linear-to-t from-white via-white/80 to-transparent dark:from-gray-900 dark:via-gray-900/80"
    ></div>
  </div>
  <Teleport to="body">
    <AiAssistantPanel
      v-if="isOpen"
      :anchored="showSidePanel"
      :dockable="supportsAnchor && isWideLayout"
      @close="close"
      @toggle-dock="toggleDock"
      @resize="setDockedWidth"
      @load-mock="loadMockConversation"
    />
  </Teleport>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AiAssistantPanel from '@/views/layouts/main-layout/ai-assistant/AiAssistantPanel.vue'

const WIDE_LAYOUT_QUERY = '(min-width: 1400px)'
const ANCHOR_SUPPORT_QUERY = 'anchor-name: --ai-assistant-anchor'

export default {
  name: 'AiAssistantContainer',
  components: { AiAssistantPanel },
  data() {
    return {
      isWideLayout: false,
      supportsAnchor: false,
      mediaQueryList: null
    }
  },
  computed: {
    ...mapGetters({
      isOpen: 'aiAssistant/isOpen',
      manualDocked: 'aiAssistant/manualDocked',
      dockedWidth: 'aiAssistant/dockedWidth'
    }),
    showSidePanel() {
      if (!this.isOpen || !this.supportsAnchor || !this.isWideLayout) {
        return false
      }
      return this.manualDocked === null ? true : this.manualDocked
    }
  },
  mounted() {
    this.supportsAnchor =
      typeof CSS !== 'undefined' && CSS.supports(ANCHOR_SUPPORT_QUERY)
    this.mediaQueryList = window.matchMedia(WIDE_LAYOUT_QUERY)
    this.isWideLayout = this.mediaQueryList.matches
    this.mediaQueryList.addEventListener('change', this.updateIsWideLayout)
  },
  beforeUnmount() {
    this.mediaQueryList?.removeEventListener('change', this.updateIsWideLayout)
  },
  methods: {
    ...mapActions({
      close: 'aiAssistant/close',
      setManualDocked: 'aiAssistant/setManualDocked',
      setDockedWidth: 'aiAssistant/setDockedWidth',
      loadMockConversation: 'aiAssistant/loadMockConversation'
    }),
    updateIsWideLayout(event) {
      this.isWideLayout = event.matches
    },
    toggleDock() {
      this.setManualDocked(!this.showSidePanel)
    }
  }
}
</script>

<style scoped>
.ai-assistant-anchor {
  anchor-name: --ai-assistant-anchor;
}
</style>
